<template>
  <div>
    <LoginForm
      :signingIn="signingIn"
      @login="signin"
      @createAnAccountButton="createAnAccountButton"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import { error } from "@/services/LoggerService";
import { login } from "@/mixins/shared";
import { useStore } from "@/store";
import mixins from "vue-typed-mixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";

export default mixins(SnackbarNotifierMixin).extend({
  name: "Login",
  components: { SnackbarNotifier, LoginForm },
  data() {
    return {
      signingIn: "off",
    };
  },
  methods: {
    async signin({ email, password }) {
      try {
        this.signingIn = "on";
        const result = await login(email, password);
        if (!result) {
          this.signingIn = "off";
          return;
        }
        const vm = this;

        if (result.challengeName == "NEW_PASSWORD_REQUIRED") {
          this.$nextTick(() => {
            vm.$router.push({
              name: "ConfirmAccount",
              params: { email: email },
            });
          });

          return;
        }
        const groups = useStore().getters.getGroups;
        this.$nextTick(() => {
          if (groups.includes("Admin") || groups.includes("Worker"))
            vm.$router.push({ name: "Admin" });
          else vm.$router.push({ name: "MyBarrels" });
        });
        this.signingIn = "off";
      } catch (e) {
        error(e);
        this.signingIn = "off";
        this.handleError(e);
      }
    },
    createAnAccountButton() {
      this.$router.push({ name: "Signup" });
    },
    handleError(e) {
      if (
        e.message == "User does not exist." ||
        e.message == "Incorrect username or password."
      ) {
        this.showNotifier({
          message: `Email or Password incorrect`,
          snackbarType: "error",
        });

        return;
      }

      if (e.message == "User is not confirmed.") {
        this.showNotifier({
          message: `Please check your email for the confirmation link`,
          snackbarType: "error",
        });

        return;
      }

      this.showNotifier({
        message: `Unsucessful signin`,
        snackbarType: "error",
      });
    },
  },
});
</script>

<style scoped></style>
